import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {ProductBarcodeSearchPageComponent} from "../product-barcode-search-page/product-barcode-search-page.component";
import {ProductBarcodeSearchModel} from "../product-barcode-search.model";

@Component({
    selector: "wbo-product-barcode-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(ProductBarcodeSingleSelectEditControlComponent),
        provideSearchModel(ProductBarcodeSearchModel)
    ]
})
export class ProductBarcodeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ProductBarcodeSearchModel> {

    constructor(model: ProductBarcodeSearchModel, injector: Injector) {
        super(model, injector, "productBarcodeId", "fullName");
        this.labelSearchField = "identifier";
        this.extendedSearchComponent = ProductBarcodeSearchPageComponent;
    }
}
